import IDeviceStore from "@/models/modelStore/IDeviceStore";
import IDataInfo from "@/models/modelView/IDataInfo";
import ModemStrategyFactory from "@/strategies/modem.strategy/modem.strategy.factory";
import FormatDate from "@/utils/date.util";
import { MapsUtil } from "@/utils/maps.util";
import BasePopup from "./base.popup";
import DeviceUtil from "@/utils/device.util";

export default class DevicesPopup implements BasePopup {
    device: IDeviceStore
    offSet = [0, -9]

    constructor(feature: any) {
        this.device = feature.get("device")
    }
    getParamsAddress(): { id: string; lat: number; lon: number; } {
        return {
            id: 'dev_' + this.device.id,
            lat: this.device.position!.latitude,
            lon: this.device.position!.longitude,
        }
    }
    getContent(): string {
        const attributes: IDataInfo[] = ModemStrategyFactory.create(this.device.model).mapAttributes(this.device?.position?.attributes, this.device)
        let extraRows = ''
        attributes.forEach(item => {
            extraRows += `
            <div class="lineas">
                <p class="propiedad m-0">${item.title} </p>
                <p class="valor m-0 ms-1">${item.value}</p>
            </div>
            `
        })
        return `
        <div class="cajatitle">
            <img src=${require('@/assets/img/devices/' + this.device.icon + '.png')} >
            <p class="m-0 ms-1 fw-bold fs-6">${this.device.name}</p>
        </div>
        <hr >
        <div class="lineas">
            <p class="propiedad m-0">Fecha: </p>
            <p class="valor m-0 ms-1">${FormatDate.getGenericFormat(this.device.position?.deviceTime || this.device.position?.serverTime || this.device.position?.fixTime || '')}</p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Velocidad: </p>
            <p class="valor m-0 ms-1">${DeviceUtil.formatKnToKmh(this.device.position?.speed)} Km/h</p>
        </div>
        ${extraRows}
        <div class="lineas">
            <p class="propiedad m-0">Dirección: </p>
            <p class="valor m-0 ms-1" id="dev_${this.device.id}"></p>
        </div>
         <div class="lineas">
            <a class="link" href="${MapsUtil.getGoogleMapsURL(this.device?.position?.latitude, this.device?.position?.longitude)}" target="_blank" rel="noopener noreferrer">Link Google Maps</a>
        </div>`
    }

}